import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../common/LoadingPanel";
import TovarFoto from "../common/TovarFoto";
import ZoznamBalikovVDodavke from "./PrijomDodavok/ZoznamBalikovVDodavke";
import ZoznamArtiklovVBaliku from "./PrijomDodavok/ZoznamArtiklovVBaliku";
import { nahlasenieDodavkyController } from "../../controllers/nahlaseniedodavky.controller";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../common/Localization";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum, LogLevel, RoleNames } from "../../enums";
import confirmService from "../common/confirmService";
import { logController } from "../../controllers/log.controller";
import { authenticationService } from "../../services/authentication.service";

class DetailDodavkyDialogContent extends Component {
    state = {
        loading: true,
        baliky: null,
        artikle: [],
        titleArtikle: null,
        nazevArtikel: null,
        footerArtikle: null,
        selectedBalikId: null,
        selectedPacking: null,
        selectedIdVariant: null,
        typRazeni: "0",
        footerCelkovyRozdil: null,
        footerPocetPrijatych: null,
        errorMessage: null,
        nesuladPoradiChyba: false,
        opravitButtonDisabled: false
    };

    getData = (showZrusenieConfirm = false) => {
        var localizationService = provideLocalizationService(this);
        nahlasenieDodavkyController.getBalikyByIdDodavka(this.props.selectedDodavkaId, this.state.typRazeni).then((data) => {
            var selectedBalikId = this.state.selectedBalikId;
            if (data.title) this.props.changeTitle(data.title);
            var errorMessage = data.errorMessage == "" ? null : data.errorMessage;
            if (errorMessage) {
                logController.logMessage(errorMessage, LogLevel.Error);
            }
            this.setState(
                {
                    baliky: data.baliky,
                    footerCelkovyRozdil: data.footerCelkovyRozdil,
                    footerPocetPrijatych: data.footerPocetPrijatych,
                    selectedBalikId: null,
                    errorMessage: errorMessage,
                    nesuladPoradiChyba: data.nesuladPoradiChyba,
                    loading: false
                },
                () => {
                    if (selectedBalikId > 0) {
                        this.changeSelectedBalikId(selectedBalikId);
                        if (showZrusenieConfirm) {
                            confirmService.show({
                                type: MessageTypeEnum.INFORMATIVE,
                                message: localizationService.toLanguageString(
                                    "PríjemPodrobne.Ukončenie balíka bolo úspešne zrušené !",
                                    "Ukončenie balíka bolo úspešne zrušené !"
                                )
                            });
                        }
                    }
                }
            );
        });
    };

    componentDidMount() {
        this.getData();
    }

    changeSelectedBalikId = (selectedBalikId) => {
        const { polozky, titleArtikle, footerArtikle, packing } = this.state.baliky.filter((balik) => balik.idBaliku == selectedBalikId)[0];
        this.setState({
            selectedBalikId: selectedBalikId,
            selectedPacking: packing,
            artikle: polozky,
            titleArtikle: titleArtikle,
            footerArtikle: footerArtikle
        });
    };

    changeSelectedArtikel = (selectedIdVariant, selectedNazev) => {
        this.setState({
            selectedIdVariant: selectedIdVariant,
            nazevArtikel: selectedNazev
        });
    };

    handleChangeRazeni = (event) => {
        event.preventDefault();
        this.setState({ typRazeni: event.target.value, loading: true, selectedBalikId: null, selectedIdVariant: null }, () => this.getData());
    };

    handleZrusitUkoncenie = async () => {
        var localizationService = provideLocalizationService(this);
        if (!this.state.selectedBalikId) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString("PríjemPodrobne.Vyberte balík zo zoznamu !", "Vyberte balík zo zoznamu !")
            });
            return;
        }
        var message = localizationService.toLanguageString("PríjemPodrobne.Chcete zrušiť ukončenie balíka <P1> ?", "Chcete zrušiť ukončenie balíka <P1> ?");
        message = message.replace(/<P1>|\{0}/, this.state.selectedBalikId);
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: message,
            buttons: ButtonGroupEnum.OK_CANCEL,
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.OK) {
            nahlasenieDodavkyController.zrusitUkoncenieBalika(this.state.selectedBalikId, this.state.selectedPacking).then(async (response) => {
                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                } else {
                    this.setState({ loading: true, selectedBalikId: null, selectedPacking: null });
                    this.getData(true);
                    if (this.props.reloadGrid) this.props.reloadGrid();
                }
            });
        }
    };

    opravitNesuladPoradi = async () => {
        var localizationService = provideLocalizationService(this);
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: localizationService.toLanguageString(
                "PríjemPodrobne.Chcete opravdu opraviť nesúlad poradí skenovania balíka ?",
                "Chcete opravdu opraviť nesúlad poradí skenovania balíka ?"
            ),
            buttons: ButtonGroupEnum.OK_CANCEL,
            logMessage: true
        });
        if (confirmResult == ButtonMessageEnum.OK) {
            this.setState({ opravitButtonDisabled: true });
            nahlasenieDodavkyController.opravitNesuladPoradi(this.props.selectedDodavkaId).then(async (response) => {
                if (response.errorMessage) {
                    await confirmService.show({
                        type: response.messageType,
                        message: response.errorMessage,
                        logMessage: true
                    });
                } else {
                    this.setState({ loading: true, selectedBalikId: null, selectedPacking: null });
                    this.getData();
                    if (this.props.reloadGrid) this.props.reloadGrid();
                }
            });
        }
    };

    renderDialogContent() {
        var localizationService = provideLocalizationService(this);
        return (
            <div id="NahlasenieDodavkyDialog">
                <div>
                    <div className="col-lg-6">
                        <ZoznamBalikovVDodavke items={this.state.baliky} changeSelectedBalikId={this.changeSelectedBalikId} />
                    </div>

                    <div className="col-lg-3">
                        <ZoznamArtiklovVBaliku
                            selectedBalikId={this.state.selectedBalikId}
                            items={this.state.artikle}
                            changeSelectedArtikel={this.changeSelectedArtikel}
                            title={this.state.titleArtikle}
                        />
                    </div>

                    <div className="col-lg-3">
                        <TovarFoto idVariant={this.state.selectedIdVariant} />
                        <div className="nazev-artikel">{this.state.nazevArtikel}</div>
                        <div className="ukonceni-baliku">
                            <Button disabled={this.props.zruseniEnabled != true} onClick={this.handleZrusitUkoncenie} className="auto-focus">
                                <Localization messageKey={"PríjemPodrobne.Zrušiť ukončenie balíka"} defaultMessage={"Zrušiť ukončenie balíka"} />
                            </Button>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="col-lg-6">
                        <div className="col-xs-7">
                            <label htmlFor="typRazeni">{localizationService.toLanguageString("PríjemPodrobne.Radenie balíkov", "Radenie balíkov")}</label>
                            <select id="typRazeni" className="form-control w-150" onChange={this.handleChangeRazeni} defaultValue={this.state.typRazeni}>
                                <option value="0">{localizationService.toLanguageString("PríjemPodrobne.Podľa čísla balíka", "Podľa čísla balíka")}</option>
                                <option value="1">
                                    {localizationService.toLanguageString("PríjemPodrobne.Podľa času skenovania", "Podľa času skenovania")}
                                </option>
                            </select>
                        </div>
                        <div className="col-xs-5 text-right">{this.state.footerPocetPrijatych}</div>
                    </div>
                    <div className="col-lg-3">
                        <div className="form-group">
                            <div className="col text-right">{this.state.footerArtikle}</div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="form-group">
                            <div className="col text-right">{this.state.footerCelkovyRozdil}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();
        contents =
            this.state.errorMessage == null ? (
                contents
            ) : (
                <div>
                    <div className="alert alert-danger">{this.state.errorMessage}</div>
                    {this.state.nesuladPoradiChyba && authenticationService.hasCurrentUserRole(RoleNames.Administrator) ? (
                        <Button onClick={this.opravitNesuladPoradi} disabled={this.state.opravitButtonDisabled}>
                            <Localization messageKey={"PríjemPodrobne.Opraviť nesúlad poradí"} defaultMessage={"Opraviť nesúlad poradí"} />
                        </Button>
                    ) : (
                        <React.Fragment />
                    )}
                </div>
            );
        return <div>{contents}</div>;
    }
}

export default DetailDodavkyDialogContent;

registerForLocalization(DetailDodavkyDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/DetailDodavkyDialogContent.js